module.exports = __webpack_public_path__ + "static/media/location-marker.min.e1daff24.svg";